// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__tCLma","ranges":"BmiRanges_ranges__3LaRc"};